






import { ColDef, GridOptions } from 'ag-grid-community';
import { Vue, Prop, Component } from 'vue-property-decorator';
import MantenedorGrid from './MantenedorGrid.vue';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { Funcionalidades } from '@/config/funcionalidades';
@Component({ components: { MantenedorGrid } })
export default class MantenedorGridSinCodigo extends Vue {
  @Prop({ default: {} }) readonly gridOptions: GridOptions;
  @Prop({ required: true }) readonly funcionalidadId: Funcionalidades;
  @Prop({}) readonly lastColumnDef: ColDef;
  @Prop({}) readonly codigoColumnField: string;
  @Prop({ default: false }) readonly verCheckbox: boolean;
  @Prop({ default: true }) readonly mostrarAcciones: boolean;
  @Prop({ default: true }) readonly verCheckboxColumna: boolean;
  get enrichedGridOptions() {
    const checkboxDef = this.verCheckbox
      ? { ...checkboxColumnDef, headerCheckboxSelection: true }
      : checkboxColumnDef;

    let columnDefs: any[] = [];
    if (this.verCheckboxColumna) {
      columnDefs = [
        {
          ...checkboxDef,
          cellStyle: { 'pointer-events': 'none' },
        },
        ...this.gridOptions.columnDefs,
      ];
    } else {
      columnDefs = this.gridOptions.columnDefs;
    }
    if (this.mostrarAcciones) {
      columnDefs.push(
        this.lastColumnDef || makeAccionesColumnDef(this.funcionalidadId)
      );
    }
    return {
      ...this.gridOptions,
      columnDefs,
    };
  }
}
